
export const WEEKDAYS_LONG = {
  'en': ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  'sv': ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'],
};

export const WEEKDAYS_SHORT = {
  'en': ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  'sv': ['Sön', 'Mån', 'Tis', 'Ons', 'Tor', 'Fre', 'Lör'],
};

export const WEEKDAYS_SHORTER = {
  'en': ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  'sv': ['Sö', 'Må', 'Ti', 'On', 'To', 'Fr', 'Lö'],
};

export const MONTHS = {
  'en': ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  'sv': ['Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December'],
};



// WEBPACK FOOTER //
// ./src/i18n/timeLocaleData.js